// extracted by mini-css-extract-plugin
export default {"loader":"ManyPhotosDropzone_loader__Tc5He","rotation":"ManyPhotosDropzone_rotation__T9fjg"};